import { createFileRoute } from "@tanstack/react-router"
import { BackofficeReferrals } from "modules/backoffice/components/referrals"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { BackofficeReferralsSortSchema } from "schema"
import { z } from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchBackofficeReferralsSchema = PaginationSearchSchema.merge(
  SearchQuerySchema,
).merge(BackofficeReferralsSortSchema.shape.sortBy.unwrap())

export const Route = createFileRoute("/_base/_auth/backoffice/referrals/list")({
  component: BackofficeReferrals,
  validateSearch: (search: Partial<z.infer<typeof SearchBackofficeReferralsSchema>>) =>
    SearchBackofficeReferralsSchema.parse(search),
})
